import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const data = [
  { name: "0-1", employees: 100, fill: "#6a0dad" },
  { name: "2-4", employees: 300, fill: "#00a86b" },
  { name: "5-7", employees: 100, fill: "#ff8c00" },
  { name: "9-11", employees: 200, fill: "#1e90ff" },
  { name: "11-20", employees: 50, fill: "#ff1493" },
];

const CustomBar = ({ x, y, width, height, payload }) => {
  return (
    <g>
      {/* Single colored rounded bar */}
      <rect
        x={x}
        y={y}
        width={width}
        height={height}
        rx={10}
        ry={10}
        fill={payload.fill}
      />
    </g>
  );
};

const TimeTakenChart = () => (
  <div
    style={{
      height: "400px",
      alignItems: "center",
      gap: "0px",
      background: "#FFF",
      padding: "50px 30px",
      borderRadius: "15px",
      border: "1px solid #CDCDCD",
      boxShadow: "2px 4px 5px #DDD",
    }}
  >
    <h5 style={{ marginBottom: "20px" }}>Employees Time Distribution</h5>
    <hr />
    <ResponsiveContainer width="100%" height="100%">
      <BarChart
        data={data}
        margin={{ top: 20, right: 30, left: 20, bottom: 20 }}
      >
        <XAxis
          dataKey="name"
          label={{
            value: "Time Interval (mins)",
            position: "insideBottom",
            dy: 10,
          }}
        />
        <YAxis
          label={{ value: "employees", angle: -90, position: "insideLeft" }}
        />
        <Tooltip />
        {/* <Legend /> */}
        <Bar
          dataKey="employees"
          shape={<CustomBar />}
          background={{ fill: "#eee" }}
        />
      </BarChart>
    </ResponsiveContainer>
  </div>
);

export default TimeTakenChart;
